export const searchPageTestIDs = {
  searchPage: 'search_page',
  header: 'search_page_header',
};
